import { Tracker } from '../../analytics/services/Tracker';

export function recordPositionStaffingTelemetry(input: {
  action: 'fill_role' | 'assign' | 'move' | 'unassign' | 'change_assignment_type' | 'transition' | 'create' | 'edit' | 'reparent' | 'add_secondary_reporting' | 'add_seat' | 'duplicate' | 'retire' | 'retire_person';
  mode: 'live' | 'scenario';
  outcome: 'applied' | 'staged' | 'noop' | 'blocked';
}): void {
  // Closed property set: no folder, position, person, assignment, source, or
  // change-set identifiers can cross this analytics boundary.
  Tracker.track('atlas.position.staffing_updated', {
    contractVersion: 'atlas-position-staffing-telemetry.v1',
    action: input.action,
    mode: input.mode,
    outcome: input.outcome,
  });
}
